import React from 'react'

import {AddUser_Manager} from "../../../model/manager"
import UsersToAdd from "../../../model/collection"
import PopupMenuButton from "../../../../../gd-components/popover-menu/popup-menu-button/popup-menu-button"
import ModalAddUser_SectionMoreMenu from "./more-menu"

type Props = {
    className?  : string

    manager     : AddUser_Manager
    usersToAdd  : UsersToAdd
}

// "More" button next to a section title (Project / Workspace / Company Users)
// Visible only while the title wrapper (.show-hidden-on-hover) is hovered or the menu is open
export default function ModalAddUser_SectionMoreButton(props: Props) {

    if (
        !props.manager.multiselect
        || _.isEmpty(props.usersToAdd.available)
    ) {
        return null
    }

    const btnComponent = (state: any) => {
        const classes = Classes("more-button ui5-control-button s-24 fs-20 ui5-ico-more", {
            'show-popover': state.showPopover
        })

        return <div className={classes}/>
    }

    return (
        <PopupMenuButton
            className           = {Classes("visible-on-parent-hover visible-on-show-popover", props.className)}
            btnComponent        = {btnComponent}
            attachment          = "top center"
            targetAttachment    = "bottom center"
            offset              = "0 0"
            menuComponent       = {ModalAddUser_SectionMoreMenu}
            menuParams          = {{
                manager     : props.manager,
                usersToAdd  : props.usersToAdd,
            }}
        />
    )
}
